export default class Initialization {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store, notifications) {
        this._store = store;
        this._notifications = notifications;
    }

    getPromise() {
        if (!this._settings.notificationsApi.pollStartActions.length || this.isPollingActive()) this._notifications.startPolling();
        return Promise.resolve();
    }

    isPollingActive() {
        return this._store.getState()
            [this._settings.stateLocations.AlmeNotifications.Base]
            [this._settings.stateLocations.AlmeNotifications.pollingActive];
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/handlers/initialization.js